import styled from 'styled-components'

import {
  Filter,
  FilterContainer,
  FilterSearchInput,
  Input,
} from '@sketch/components'

export const SearchField = styled(Filter)<{
  expand: boolean
}>`
  ${FilterContainer}, ${FilterSearchInput} {
    height: 32px;
  }

  ${Input} {
    position: relative;
    width: 100%;
    background: none;
    max-width: ${({ expand }) => (expand ? '100%' : '196px')};
    border-color: ${({ theme }) => theme.colors.border.A};
  }
`
